import store from '@/store'

export default [
  {
    path: '/products',
    name: 'product',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/index.vue')
  },
  {
    path: '/products/create',
    name: 'product-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('product/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/products/:id',
    name: 'product-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('product/dataBeforeCreate')
      await store.dispatch('product/find', to.params.id)
      next()
    }
  }
]
